import axios from 'axios';
import API_HOST from '../api';

const severityApi = function() {
  const api = {};

  api.getSeverityList = function() {
    const url = `${API_HOST}/api/severity-list`;
    return axios.get(url);
  };

  api.getDefaultProductSeverityList = function(clientId) {
    const url = `${API_HOST}/api/client/${clientId}/product-severity-list`;

    return axios.get(url);
  };

  api.updateDefaultProductSeverity = function(clientId, productId, severityId) {
    const url = `${API_HOST}/api/client/${clientId}/product/${productId}/severity`;

    return axios.put(url, { id: severityId });
  };


  return api;
};

export default severityApi();
